module.exports = __webpack_public_path__ + "img/zan.686beca7.png";